import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Heading } from '../../atoms';
import { Modal } from '../../components';
import { useReporter } from '../../reporter';
import {
  viewedVetServicesModalEvent,
  initiateVetServicesEvent,
} from './events';
import {
  ButtonContainer,
  Container,
  Disclaimer,
  MainSection,
  Icon,
  ItemContainer,
  ItemTextContainer,
  ItemHeading,
  ItemText,
} from './styles';

export const VetServicesModal = ({
  ctaButtonText,
  disclaimer,
  headline,
  items,
  shown,
  onClickClose,
  onCtaClick,
}) => {
  const reporter = useReporter();

  useEffect(() => {
    shown && reporter.tag(viewedVetServicesModalEvent());
  }, [reporter, shown]);

  const handleCtaClick = () => {
    reporter.tag(initiateVetServicesEvent());
    onCtaClick();
  };

  return (
    <Modal
      ariaHideApp={false}
      shown={shown}
      onCloseModal={onClickClose}
      ariaLabel="Vet services modal"
      mobileFullScreen
    >
      <Container>
        <Heading
          headingLevel="h2"
          typography="heading2"
          headingText={headline}
        />
        <MainSection>
          {items.map(item => (
            <ItemContainer key={item.heading}>
              <Icon src={item.icon} alt={item.iconAltText} />
              <ItemTextContainer>
                <ItemHeading>{item.heading}</ItemHeading>
                <ItemText>{item.text}</ItemText>
              </ItemTextContainer>
            </ItemContainer>
          ))}
        </MainSection>
        <ButtonContainer>
          <Button
            fullWidth
            variant="sweetPotato"
            onClick={handleCtaClick}
            data-testId="vet-talk-button"
          >
            {ctaButtonText}
          </Button>
        </ButtonContainer>
        <Disclaimer>{disclaimer}</Disclaimer>
      </Container>
    </Modal>
  );
};

VetServicesModal.displayName = 'VetServicesModal';

VetServicesModal.propTypes = {
  ctaButtonText: PropTypes.string.isRequired,
  disclaimer: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  onClickClose: PropTypes.func.isRequired,
  onCtaClick: PropTypes.func.isRequired,
  shown: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      iconAltText: PropTypes.string.isRequired,
      heading: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired,
  ),
};
